import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import {EcgPorTerceirosService} from './ecg-por-terceiros.service';
import {EcgPorTerceirosRoutingModule} from './ecg-por-terceiros-routing.module';
import {EcgPorTerceirosPesquisaComponent} from './pesquisa/ecg-por-terceiros-pesquisa.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {EcgPorTerceirosListagemComponent} from './listagem/ecg-por-terceiros-listagem.component';
import {EcgPorTerceirosCadastroComponent} from './cadastro/ecg-por-terceiros-cadastro.component';

@NgModule({
  imports: [
    SharedModule,
    BrowserModule,
    CommonModule,
    EcgPorTerceirosRoutingModule,
    NgSelectModule
  ],
  exports: [],
  declarations: [
    EcgPorTerceirosPesquisaComponent,
    EcgPorTerceirosListagemComponent,
    EcgPorTerceirosCadastroComponent
  ],
  providers: [EcgPorTerceirosService],
  schemas: [],
})
export class EcgPorTerceirosModule {}
